import * as React from 'react';
import { Header } from '@gc/global-components';
import { ErrorBoundary } from 'bernie-view';
import { Qualtrics } from '@shared-ui/customer-qualtrics';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { OneKeyOnboardingWrapper } from '@shared-ui/retail-loyalty-one-key-onboarding';
import { GlobalNavigationLineOfBusiness } from '../common/__generated__/api';
import { ActivityDetail } from '../components/activity-detail';
import { MesoInit } from '../components/meso';
var ActivityDetailPage = function () {
  return React.createElement("main", {
    className: "white-canvas page-container",
    "data-testid": "activity-detail-page"
  }, React.createElement(Header, {
    lineOfBusiness: GlobalNavigationLineOfBusiness.ACTIVITY
  }), React.createElement(ErrorBoundary, {
    label: "onekey.onboarding.lx-nimble"
  }, React.createElement(OneKeyOnboardingWrapper, null)), React.createElement(React.Fragment, null, React.createElement(ErrorBoundary, {
    label: "meso.init"
  }, React.createElement(MesoInit, null))), React.createElement(ActivityDetail, null), React.createElement(Experiment, {
    name: "Activities_DUET_Gate"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(Qualtrics, null))));
};
export default ActivityDetailPage;